"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelUserServiceSchema = void 0;
const zod_1 = require("zod");
// Схема для PanelUserServiceType (partial, для использования в API)
exports.PanelUserServiceSchema = zod_1.z.object({}).passthrough();
